import { isDelistedRoute } from '../utils/delisted-routes'

export default defineNuxtRouteMiddleware((to) => {
  if (isDelistedRoute(to.path)) {
    return navigateTo('/', { redirectCode: 301, replace: true })
  }
})
